const Hero = props => {
    return (
      <section className="hero">
        <div className="content-banner">
          <h1 className="title">BECOME A B.A.N.K. TRAINER</h1>
        </div>
      </section>
    );
}

export default Hero;